module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp1_7042.9f2f3f8b.png";